import React from 'react';
import { UserEvaluationProvider } from '../../providers/userEvaluation.provider';
import UserEvaluationContainer from './UserEvaluationContainer';

const UserEvaluation: React.FC = () => {
  return (
    <>
      <UserEvaluationProvider>
        <UserEvaluationContainer />
      </UserEvaluationProvider>
    </>
  );
};

export default UserEvaluation;
